import {
  VectorStyle,
  VectorStyleLayer
} from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../twc-products';

const TWC_PIREPS_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    type: 'symbol',
    maxzoom: 28,
    layout: {
      'icon-image': [
        'case',
        ['==', ['get', 'turbulence_intensity'], 3],
        'Turbulence_Light',
        ['==', ['get', 'turbulence_intensity'], 4],
        'Turbulence_Light',
        ['==', ['get', 'turbulence_intensity'], 5],
        'Turbulence_Moderate',
        ['==', ['get', 'turbulence_intensity'], 6],
        'Turbulence_Moderate',
        ['==', ['get', 'turbulence_intensity'], 7],
        'Turbulence_Severe',
        ['==', ['get', 'turbulence_intensity'], 8],
        'Turbulence_Severe',
        'Turbulence_Nil'
      ],
      'icon-size': 0.2,
      'text-field': ['get', 'flight_level'],
      'text-variable-anchor': 'bottom',
      'text-size': [
        'case',
        ['==', ['get', 'flight_level'], 'DURGC'],
        8,
        ['==', ['get', 'flight_level'], 'DURGD'],
        8,
        10
      ],
      'icon-allow-overlap': true,
      'text-offset': [0, 1],
      'text-anchor': 'top'
    },
    paint: {
      'text-color': '#ffffff'
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'pireps_turb',
    filter: ['all', ['has', 'turbulence_intensity']]
  },
  {
    type: 'symbol',
    maxzoom: 28,
    layout: {
      'icon-image': [
        'case',
        ['==', ['get', 'icing_intensity'], 3],
        'Icing_Light',
        ['==', ['get', 'icing_intensity'], 4],
        'Icing_Moderate',
        ['==', ['get', 'icing_intensity'], 5],
        'Icing_Moderate',
        ['==', ['get', 'icing_intensity'], 6],
        'Icing_Severe',
        ['==', ['get', 'icing_intensity'], 7],
        'Icing_Severe',
        ['==', ['get', 'icing_intensity'], 8],
        'Icing_Severe',
        'Icing_Nil'
      ],
      'icon-size': 0.2,
      'text-field': ['get', 'flight_level'],
      'text-size': [
        'case',
        ['==', ['get', 'flight_level'], 'DURGC'],
        8,
        ['==', ['get', 'flight_level'], 'DURGD'],
        8,
        10
      ],
      'icon-allow-overlap': true,
      'text-offset': [0, 1],
      'text-anchor': 'top',
      position: 'absolute'
    },
    paint: {
      'text-color': '#ffffff'
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'pireps_icing',
    filter: ['all', ['has', 'icing_intensity']]
  },
  {
    type: 'symbol',
    maxzoom: 28,
    layout: {
      'icon-image': 'Other',
      'icon-size': 0.2,
      'text-field': ['get', 'flight_level'],
      'text-variable-anchor': 'bottom',
      'text-size': [
        'case',
        ['==', ['get', 'flight_level'], 'DURGC'],
        8,
        ['==', ['get', 'flight_level'], 'DURGD'],
        8,
        10
      ],
      'icon-allow-overlap': true,
      'text-offset': [0, 1],
      'text-anchor': 'top'
    },
    paint: {
      'text-color': '#ffffff'
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'pireps_other',
    filter: ['all', ['==', 'turbulence_text', ''], ['==', 'icing_text', '']]
  }
];

export const TWC_PIREPS_VECTOR_STYLE: VectorStyle = {
  layers: TWC_PIREPS_VECTOR_STYLE_LAYERS,
  sprite: `assets/weather/sprites/PIREPs/PIREPs`,
  glyphs: `assets/weather/glyphs/Font11_Regular/0-255.pbf`
};

export const PIREPS_PRODUCT_DATA: TwcProduct = {
  id: 'pireps',
  defaultProductId: '6009',
  productName: 'Weather-PIREPS-TWC',
  label: 'PIREPs',
  weatherType: 'PIREP',
  description: 'TWC product (vector) - PIREP',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 7,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    vectorTile: { vectorStyle: TWC_PIREPS_VECTOR_STYLE }
  }
};
